"use strict";

module.exports = function getUserAgent() {
  return window.navigator.userAgent;
};